import React from 'react'
import styled from 'styled-components'
import { getStyles } from '@conversionbuddy/Layout'
import {
    useInternalParam,
    InternalParamsConstants,
} from '../../../hooks/useInternalParams'
import { identity } from '../../../utils'

const StyledClaim = styled.div`
    ${getStyles()}
`

export const Claim = ({ classes }) => {
    const claim = useInternalParam(
        InternalParamsConstants.CLAIM,
        identity,
    )
    return claim ? (
        <StyledClaim classes={classes}>{claim}</StyledClaim>
    ) : null
}
